module.exports = __webpack_public_path__ + "static/media/number-item-8.93fc4021.png";